import React from 'react';

type InputProps = {
  Icon?: JSX.Element;
  label: string;
  count?: number;
  iconOnly?: boolean;
};

export const UiIconTabLabel = ({ Icon, label, count, iconOnly }: InputProps) => {
  if (iconOnly && Icon) {
    return Icon;
  }

  const truncatedCount = count && count > 0 ? (count >= 99 ? ` (99+)` : ` (${count})`) : '';

  return (
    <div className="u-display-flex u-alignItems-center">
      {Icon || null}
      <div className={Icon ? 'u-margin-left-sm' : ''}>
        {label}
        {truncatedCount}
      </div>
    </div>
  );
};
